
import { IEnvironment } from '../types';

export async function ReadVariables(): Promise<IEnvironment> {
    const fetchResponse = await fetch('env.json');
    return await fetchResponse.json();
}